import {GridElementModel} from './grid.element.model';
import {DxDataGridComponent} from 'devextreme-angular';
import {EventEmitter} from "@angular/core";
export class GridModel {
  rows: GridElementModel[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
  columns: [any];
  dataGrid: DxDataGridComponent;
}

export class GridRequest {
  options: any;
}

export class GridResponse {
  rows: GridElementModel[];
  totalCount: number;
  summary: any;
}

export class GridConfiguration {

  customSearch: [{
    fieldName: string;
    value: string;
  }];

  service: any;

  remoteOperations = {
    filtering: true,
    sorting: true,
    paging: true,
    grouping: true,
    summary: true
  };

  paging = {
    enabled: true,
    pageIndex: 0,
    pageSize: 10
  };

  pager = {
    showPageSizeSelector: true,
    showNavigationButtons: true,
    allowedPageSizes: [10, 20],
    pageSize: 10,
    showInfo: ''
  };

  selection: any = {
    mode: 'multiple',
    showCheckBoxesMode : 'always',
    allowSelectAll: false
  };

  sorting: any = false; // { mode: single };
  filterRow: any; // { visible: true };

  searchPanel: any; // { visible: true },

  columnAutoWidth = false;
  allowColumnResizing = true;

  columns: [any];
  dataGrid: DxDataGridComponent;
  rowsDataSource: [any];

  onRowClick = new EventEmitter<any>();

  summary: any;


  mapGridRequest(gridRequest: GridRequest, loadOptions: any) {
    if (!gridRequest.options)
      gridRequest.options = {};

    gridRequest.options.filter = loadOptions.filter;
    gridRequest.options.group = loadOptions.group;
    gridRequest.options.requireTotalCount = loadOptions.requireTotalCount;
    gridRequest.options.searchExpr = loadOptions.searchExpr;
    gridRequest.options.searchOperation = loadOptions.searchOperation;
    gridRequest.options.skip = loadOptions.skip;
    gridRequest.options.sort = loadOptions.sort;
    gridRequest.options.take = loadOptions.take;

  }
  refreshGrid() {
    this.dataGrid.instance.getDataSource().reload();
  }
  reloadGrid() {
    this.dataGrid.instance.clearSelection();
    this.dataGrid.instance.clearGrouping();
    this.dataGrid.instance.clearSorting();
    this.dataGrid.instance.getDataSource().reload();
  }
  getSelected() {
    return this.dataGrid.instance.getSelectedRowsData();
  }
}






// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/shared/grid/grid.model.ts